import { render } from "./registrationStep1.vue?vue&type=template&id=2200e172&scoped=true"
import script from "./registrationStep1.vue?vue&type=script&lang=js"
export * from "./registrationStep1.vue?vue&type=script&lang=js"

import "./registrationStep1.vue?vue&type=style&index=0&id=2200e172&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2200e172"]])

export default __exports__